import { IRecipe } from '../_types'
import { request } from './http-client'

const recipeService = {
  getList: (params: { page: number; limit: number }, shipperId?: string) =>
    request.get<{ recipes: IRecipe[]; count: string }>('/v2/recipes', {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  getById: (slug: string, shipperId?: string) =>
    request.get<IRecipe>(`/v2/recipes/${slug}`, {
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
}

export default recipeService
